// bootstrap components
import Image from 'next/image'

// components
import { Card } from '@centria-ui-atoms/card'
import { AuthHeroQuote } from '../quote'

// styles
import classes from './styles.module.scss'

// types
import type { AuthHeroQuoteProps } from '../quote'
import type { StaticImageData } from 'next/image'
import type { FC } from 'react'

type DesktopHeroProps = {
  quote?: AuthHeroQuoteProps
  backgroundImage: StaticImageData
}

export const DesktopHero: FC<DesktopHeroProps> = ({
  quote,
  backgroundImage
}) => (
  <div className={classes.desktop}>
    <div className={classes.background}>
      <div className={classes.shadow} />
      <Image
        width={200}
        height={200}
        alt='background'
        src={backgroundImage}
        className={classes.image}
      />
    </div>

    {quote && (
      <Card className={classes.text} cardBody={<AuthHeroQuote {...quote} />} />
    )}
  </div>
)
